export interface TooltipState {
  arrowStyleOverrides: TooltipArrowStyleOverride;
  placement: string;
  visibility: string;
  wrapperStyles: TooltipWrapperStyle;
  isFirstActiveTooltip: boolean;
}

export interface TooltipArrowStyleOverride {
  left?: string;
}

export interface TooltipWrapperStyle {
  left?: string;
  top?: string;
}

export enum Placement {
  Top = `top`,
  Right = `right`,
  Bottom = `bottom`,
  Left = `left`,
}

export enum DisplayType {
  Default = `default`,
  Error = `error`,
  Chart = `chart`,
}
